import { useFormik } from "formik";
import React, { useState } from "react";
import DashboardLayout from "../../Components/LayoutContainers/DashboardLayout";
import MDBox from "../../Components/MDBox";
import DashboardNavbar from "../../Components/Navbars/DashboardNavbar";
import * as Yup from "yup";
import MDDivider from "../../Components/MDDivider";
import MDInput from "../../Components/MDInput";
import MDTypography from "../../Components/MDTypography";
import { Grid } from "@mui/material";
import MDButton from "../../Components/MDButton";
import { GozareshKoliModel } from "../../Api/Models/GozareshKoli";
import { ErrorToaast } from "../../utils/toast/Toast";
import { v4 as uuid } from "uuid";
import PrintIcon from "@mui/icons-material/Print";

const validationSchema = Yup.object().shape({});
export default function GozareshKoliAsnaf() {
  const [searched, setSearched] = useState<any>([]);

  var GozareshKoli = new GozareshKoliModel();
  const formik = useFormik({
    initialValues: {
      Mantaghe: "",
      Hoze: "",
      Blook: "",
    },
    onSubmit: () => {},
    validationSchema,
  });
  function handleClick() {
    GozareshKoli.GetSearch(formik.values.Mantaghe, formik.values.Hoze, formik.values.Blook)
      .then((r) => {
        setSearched(r.data.data);
      })
      .catch((e) => ErrorToaast("مشکل در برقراری ارتباط"));
  }
  return (
    <DashboardLayout>
      <DashboardNavbar name={"گزارش کلی نوسازی"} />
      <MDBox bgColor="white" borderRadius="5px" p="10px 5px">
        <MDTypography fontWeight="bold" fontSize="14px">
          مشخصات ملک
        </MDTypography>
        <MDDivider />
        <MDBox py={2}>
          <Grid container gap="14px 0" textAlign={"center"}>
            <Grid container item xs={12} alignItems="center">
              <Grid item width="150px">
                <MDTypography fontSize="15px">منطقه</MDTypography>
              </Grid>
              <Grid item flex={1}>
                <MDInput fullWidth size="small" onChange={formik.handleChange} name="Mantaghe" value={formik.values.Mantaghe} />
              </Grid>
              <Grid item width="150px">
                <MDTypography fontSize="15px">حوزه</MDTypography>
              </Grid>
              <Grid item flex={1}>
                <MDInput fullWidth size="small" onChange={formik.handleChange} name="Hoze" value={formik.values.Hoze} />
              </Grid>
              <Grid item width="150px">
                <MDTypography fontSize="15px">بلوک</MDTypography>
              </Grid>
              <Grid item flex={1}>
                <MDInput fullWidth size="small" onChange={formik.handleChange} name="Blook" value={formik.values.Blook} />
              </Grid>
            </Grid>
          </Grid>
        </MDBox>
        <MDBox my={2}>
          <Grid container columnGap={4} justifyContent="center">
            <Grid item xs={2}>
              <MDButton
                fullWidth
                variant="contained"
                onClick={() => {
                  formik.resetForm();
                  //   setEditable(0);
                }}
                color="success"
              >
                جدید
              </MDButton>
            </Grid>

            <Grid item xs={2}>
              <MDButton fullWidth variant="contained" color="primary" onClick={() => handleClick()}>
                جستجو
              </MDButton>
            </Grid>
            <Grid item xs={2}>
              <MDButton
                fullWidth
                variant="contained"
                color="warning"
                onClick={() =>
                  window.open(
                    `/webroutes/GozareshNosazi/search?Mantaghe=${formik.values.Mantaghe}&Hoze=${formik.values.Hoze}&Blook=${formik.values.Blook}`,
                    "_blank"
                  )
                }
              >
                چاپ
              </MDButton>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
      <MDBox bgColor="white" borderRadius="5px" p="10px 5px">
        <MDTypography fontWeight="bold" fontSize="14px">
          مشخصات ملک
        </MDTypography>
        <MDDivider />
        <MDBox minHeight="40vh" maxHeight="40vh" sx={{ overflow: "auto" }} bgColor="#adaabb" mt={1} border="2px #5b5b5b solid">
          <MDBox bgColor="#eeeeee" px={1}>
            <Grid container columns={10} textAlign="center">
              <Grid item xs={1}>
                <MDTypography fontSize={"14px"}>منطقه</MDTypography>
              </Grid>
              <Grid item xs={1}>
                <MDTypography fontSize={"14px"}>حوزه</MDTypography>
              </Grid>
              <Grid item xs={1}>
                <MDTypography fontSize={"14px"}>بلوک</MDTypography>
              </Grid>
              <Grid item xs={1}>
                <MDTypography fontSize={"14px"}>نام</MDTypography>
              </Grid>
              <Grid item xs={1}>
                <MDTypography fontSize={"14px"}>نام خانوادگی</MDTypography>
              </Grid>
              <Grid item xs={1}>
                <MDTypography fontSize={"14px"}>کد ملی</MDTypography>
              </Grid>
              <Grid item xs={1}>
                <MDTypography fontSize={"14px"}>مبلغ نوسازی</MDTypography>
              </Grid>
              <Grid item xs={1}>
                <MDTypography fontSize={"14px"}>مبلغ پسماند</MDTypography>
              </Grid>
              <Grid item xs={1}>
                <MDTypography fontSize={"14px"}>مبلغ کلی</MDTypography>
              </Grid>
              <Grid item xs={1}>
                <MDTypography fontSize={"14px"}>چاپ</MDTypography>
              </Grid>
            </Grid>
          </MDBox>
          {searched.length > 0 &&
            searched.map((data: any, index: number) => {
              return (
                <MDBox
                  bgColor={index % 2 === 0 ? "#fbfbfb" : "white"}
                  px={1}
                  key={uuid()}
                  sx={{ ":hover": { background: "#9185c8" }, cursor: "pointer" }}
                  textAlign="center"
                >
                  <Grid container columns={10}>
                    <Grid item xs={1}>
                      <MDTypography fontSize={"14px"}>{data.melkMalek.mantaghe ?? ""}</MDTypography>
                    </Grid>
                    <Grid item xs={1}>
                      <MDTypography fontSize={"14px"}>{data.melkMalek.hoze ?? ""}</MDTypography>
                    </Grid>
                    <Grid item xs={1}>
                      <MDTypography fontSize={"14px"}>{data.melkMalek.blook ?? ""}</MDTypography>
                    </Grid>
                    <Grid item xs={1}>
                      <MDTypography fontSize={"14px"}>{data.melkMalek.malekName ?? ""}</MDTypography>
                    </Grid>
                    <Grid item xs={1}>
                      <MDTypography fontSize={"14px"}>{data.melkMalek.familyName ?? ""}</MDTypography>
                    </Grid>
                    <Grid item xs={1}>
                      <MDTypography fontSize={"14px"}>{data.melkMalek.codeMeli ?? ""}</MDTypography>
                    </Grid>
                    <Grid item xs={1}>
                      <MDTypography fontSize={"14px"}>{((parseFloat(data.mablaghAvarez) * 2) / 3).toFixed(2) ?? ""}</MDTypography>
                    </Grid>
                    <Grid item xs={1}>
                      <MDTypography fontSize={"14px"}>{(parseFloat(data.mablaghAvarez) / 3).toFixed(2) ?? ""}</MDTypography>
                    </Grid>
                    <Grid item xs={1}>
                      <MDTypography fontSize={"14px"}>{parseFloat(data.mablaghAvarez).toFixed(2) ?? ""}</MDTypography>
                    </Grid>
                    <Grid item xs={1} textAlign="center">
                      <MDBox onClick={() => window.open(`/webroutes/Nosazi/${data.id}`, "_blank")}>
                        <PrintIcon color="warning" />
                      </MDBox>
                    </Grid>
                  </Grid>
                </MDBox>
              );
            })}
        </MDBox>
      </MDBox>
    </DashboardLayout>
  );
}
